export const urls = {
  account: '/account',
  credentials: {
    base: '/credentials',
  },
  devices: {
    base: '/devices',
  },
  home: '/',
  login: '/login',
  organisations: {
    base: '/organisations',
    organisation: {
      base: {
        path: '/organisations/:orgId',
        compose: (id: number) => `/organisations/${id}`,
      },
      devices: {
        path: '/organisations/:orgId/devices',
        compose: (id: number) => `/organisations/${id}/devices`,
      },
      policies: {
        path: '/organisations/:orgId/policies',
        compose: (id: number) => `/organisations/${id}/policies`,
      },
      reporting: {
        path: '/organisations/:orgId/reporting',
        compose: (id: number) => `/organisations/${id}/reporting`,
      },
      groups: {
        base: {
          path: '/organisations/:orgId/groups',
          compose: (id: number) => `/organisations/${id}/groups`,
        },
        group: {
          base: {
            path: '/organisations/:orgId/groups/:groupId',
            compose: (orgId: number, groupId: number) =>
              `/organisations/${orgId}/groups/${groupId}`,
          },
          new_unit: {
            path: '/organisations/:orgId/groups/:groupId/new-unit',
            compose: (orgId: number, groupId: number) =>
              `/organisations/${orgId}/groups/${groupId}/new-unit`,
          },
          unit: {
            path: '/organisations/:orgId/groups/:groupId/unit/:unitId',
            compose: (orgId: number, groupId: number, unitId: number) =>
              `/organisations/${orgId}/groups/${groupId}/unit/${unitId}`,
          },
        },
      },
      users: {
        path: '/organisations/:orgId/users',
        compose: (id: number) => `/organisations/${id}/users`,
        optionalUser: '/organisations/:orgId/users/:userId?',
      },
      units: {
        path: '/organisations/:orgId/units',
        compose: (id: number) => `/organisations/${id}/units`,
      },
    },
  },
  policies: {
    base: '/policies',
    organisation: {
      path: '/policies/:orgId',
      compose: (id: number) => `/policies/${id}`,
    },
  },
  reporting: {
    base: '/reporting',
  },
  importing: {
    base: '/import',
  },
  groups: {
    base: '/groups',
    group: {
      base: {
        path: '/groups/:groupId',
        compose: (id: number) => `/groups/${id}`,
      },
      new_unit: {
        path: '/groups/:groupId/new-unit',
        compose: (id: number) => `/groups/${id}/new-unit`,
      },
      unit: {
        path: '/groups/:groupId/unit/:unitId',
        compose: (groupId: number, unitId: number) =>
          `/groups/${groupId}/unit/${unitId}`,
      },
    },
  },
  users: {
    base: '/users',
    optionalUser: '/users/:userId?',
    user: {
      path: '/users/:userId',
      compose: (id: number) => `/users/${id}`,
    },
  },
  units: {
    base: '/units',
  },
};
